// Leitura do registro vinculado de um campo `form-link`.
//
// Duas chaves, dois donos:
//   - `identifier: true`   — flag do **layout** ("este campo define o
//     identificador do preenchimento"), escrita pelo construtor, igual à de
//     qualquer outro tipo de campo;
//   - `target_identifier`  — texto do registro vinculado, escrito no
//     **preenchimento** quando o usuário escolhe o registro.
//
// As duas moravam em `identifier`: ao escolher o registro, a string do
// preenchimento sobrescrevia a flag do layout — e, no salvamento, uma string
// truthy fazia o form-link ser tratado como campo identificador, zerando o
// identificador que outro campo já tinha definido. Os data forms salvos naquele
// formato continuam legíveis aqui (string em `identifier`), por isso a checagem
// de tipo: nada de migração de banco.

// Texto do registro vinculado ("" quando não há vínculo ou o alvo não tem
// identificador).
function linkedIdentifier(field) {
  if (!field) return "";
  if (field.target_identifier) return String(field.target_identifier);
  return typeof field.identifier === "string" ? field.identifier : "";
}

// O que vira o identificador do preenchimento quando o form-link está marcado
// como identificador no layout. Registro vinculado sem identificador cai para o
// id (`#42`) — é o mesmo id que o seletor mostra, e sem isso o preenchimento
// ficaria sem referência nenhuma na listagem.
function formLinkIdentifier(field) {
  const text = linkedIdentifier(field);
  if (text) return text;

  const id = field && field.target_data_form_id;
  return id ? `#${id}` : "";
}

export { linkedIdentifier, formLinkIdentifier };
